import React from "react";

import * as S from "./styles";

const Loading = () => {
  return (
    <S.Circle className="global-loading-spinner">
      <S.CircularLoader viewBox="25 25 50 50">
        <S.LoaderPath cx="50" cy="50" r="20" />
      </S.CircularLoader>
      <S.CircularBackground viewBox="25 25 50 50">
        <S.SecondLoaderPath cx="50" cy="50" r="20" />
      </S.CircularBackground>
    </S.Circle>
  );
};

export default Loading;
